<template>
  <v-chart
    v-loading="loading"
    style="width: 100%;height: 100%"
    :options="lineOption"
    :autoresize="true"
    :init-options="{ devicePixelRatio: 1 }"
  ></v-chart>
</template>

<script>
import { CombustionLaboratoryApi } from '@wiz-api/huizhou2-business'

const combustionLaboratoryApi = new CombustionLaboratoryApi()

export default {
  name: 'lineChart',

  data() {
    return {
      loading: false,
      lineOption: {
        color: ['#feff01'],
        legend: {
          data: ['出库样品/月'],
          textStyle: {
            color: 'rgba(255,255,255,0.6)',
          },
          right: 5,
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: 40,
          left: 10,
          right: 10,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.6)',
            },
          },
          axisTick: {
            show: false,
          },
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: 'rgba(255,255,255,0.6)',
            margin: 10,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(255,255,255,0.1)',
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: '出库样品/月',
            type: 'line',
            lineStyle: {
              width: 2,
            },
            label: {
              show: true,
              color: '#41DAD4',
            },
            data: [],
          },
        ],
      }
    }
  },
  methods: {
    async initData(code) {
      this.loading = true
      const [err, res] = await combustionLaboratoryApi.getMonthlyDispatchedCount()
      if (!err && res) {
        // 提取出当前年份的数据
        const currentYear = new Date().getFullYear()
        const currentYearData = res.filter((item) => {
          return item.year === new Date().getFullYear()
        })
        const filledData = []
        for (let i = 1; i <= 12; i++) {
          const monthData = currentYearData.find((item) => {
            return item.month === i
          })
          filledData.push(monthData ? monthData.dispatchedCount : 0)
        }
        this.lineOption.series[0].data = filledData
      } else {
        this.lineOption.series[0].data = []
      }
      this.loading = false
    },
  },
  mounted() {
    this.initData()
  }
}
</script>
